import React, { FunctionComponent } from 'react';
import styles from './Bio.module.scss';
import { Block, BlockContent } from 'components/elements';
import { WPAcfBio } from 'types/acf/bio';
import { SingleWorker } from 'components/presentional';

interface OwnProps {
  data: WPAcfBio | null;
}

type BioProps = JSX.IntrinsicElements['div'] & OwnProps;

const Bio: FunctionComponent<BioProps> = props => {
  const { data } = props;

  if (!data) {
    return null;
  }

  return (
    <Block id="bio" theme="light" data-module="bio">
      <BlockContent>
        <div className={styles.wrapper}>
          <SingleWorker worker={data} />
        </div>
      </BlockContent>
    </Block>
  );
};

export default Bio;
